

  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {
    acceptedModule,
    acceptedState,
    authModule,
    challengeModule,
    forumModule,
    forumState,
    i18nModule,
    userModule,
    userState
  } from '@/utils/store-acessor';
  import {UserModel} from '@/models/user.model';
  import {TopicEvents, TopicModel} from '@/models/topic.model';
  import {LocaleSelectorType} from '@/store/i18n.store.module';
  import {ChallengeModel} from '@/models/challenge.model';
  import {Emit, Watch} from 'vue-property-decorator';
  import {noop} from 'rxjs';

  @Component({})
  export default class ChallengeForum extends Vue {
    searchParam = '';
    page = 1;
    @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;
    @userModule.Getter('user') currentUser!: UserModel;
    @challengeModule.Getter('selectedChallenge') challenge!: ChallengeModel;
    @acceptedModule.Getter('acceptedChallenges') acceptedChallenges!: ChallengeModel[];
    @acceptedModule.Getter('userHasAccepted') userHasAccepted!: (challengeId: number) => boolean;
    @i18nModule.Getter('locale') localeSelected!: LocaleSelectorType;
    @forumModule.Getter('topics') topics!: TopicModel[];
    @forumModule.Getter('lastPage') lastPage!: number;
    @forumModule.Getter('loading') loading!: boolean;
    @forumModule.Getter('isAuthor') isAuthor!: (topic: TopicModel, user: UserModel) => boolean;

    get enableButtons(): boolean {
      if (!this.challenge?.id) {
        return false
      }
      // return this.userHasAccepted(this.challenge.id)
      //         || !!this.challenge?.is_challenge_admin
      //         || !!this.challenge?.is_advisor
      //         || !!this.challenge?.is_judge
      return this.userHasAccepted(this.challenge.id)
    }

    getHeader() {
      this.headers = [
        {
          text: this.$t('forum.topic.title'),
          align: 'left',
          sortable: false,
          value: 'topic',
        },
        {
          text: this.$t('forum.last_topic'),
          align: 'left',
          sortable: false,
          value: 'last_topic',
        },
        {
          text: this.$t('forum.total'),
          align: 'left',
          sortable: false,
          value: 'total',
        },
        {
          text: this.$t('forum.actions'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ];
    }

    headers: any = [];

    @Watch('localeSelected')
    asyncTranslate() {
      this.getHeader();
    }

    async mounted() {
      this.getHeader();
      try {
        if (this.isAuthenticated && userState.contestant) {
          await acceptedState.fetchAcceptedChallenges({
            params: {page: 1}
          });
        }
      } catch (e) {
        noop();
      }
    }

    @Emit()
    onTopicEvent(event: TopicEvents): TopicEvents {
      return event;
    }

    @Watch('page')
    onPageChange(value: number) {
      if (this.challenge?.id) {
        forumState.fetchAll({
          page: value,
          challengeId: this.challenge.id
        });
      }
    }
  }
